import { CardWithIntent, Illustration, Text } from "@clipboard-health/ui-components";
import { Box, CardContent, Stack } from "@mui/material";
import { generatePath, useHistory } from "react-router-dom";

import { Button } from "../../components/Button";
import { DOCUMENT_DETAILS_FULL_PATH } from "../../Documents/paths";
import { useIsSmallHorizontalSpacing } from "../../utils/useIsSmallHorizontalSpacing";
import { useIsSmallVerticalSpacing } from "../../utils/useIsSmallVerticalSpacing";
import { type WorkerRequirement } from "../api/useFetchPaginatedPlacements";

interface PlacementDocumentRequirementsCardProps {
  requirement: WorkerRequirement;
}

export function PlacementDocumentRequirementsCard(props: PlacementDocumentRequirementsCardProps) {
  const { requirement } = props;

  const history = useHistory();
  const isSmallVerticalSpacing = useIsSmallVerticalSpacing();
  const isSmallHorizontalSpacing = useIsSmallHorizontalSpacing();

  const onClick = () => {
    history.push(
      generatePath(DOCUMENT_DETAILS_FULL_PATH, {
        requirementId: requirement.relationships.requirement.data.id,
      })
    );
  };

  return (
    <CardWithIntent intent="neutral">
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
          py: isSmallVerticalSpacing ? 1 : undefined,
          px: isSmallHorizontalSpacing ? 2 : 6,
        }}
      >
        <Stack
          alignItems="center"
          justifyContent="center"
          spacing={isSmallVerticalSpacing ? 2 : 5}
          sx={{
            textAlign: "center",
            textWrap: "balance",
            width: "100%",
            flexGrow: 1,
            mb: "auto",
          }}
        >
          <Illustration type="document-upload" />

          <Text semibold variant="h5">
            {requirement.relationships?.requirement?.data?.attributes?.name}
          </Text>

          <Text
            color={(theme) => theme.palette.text.secondary}
            variant="body2"
            data-testid="bookability-sheet-description"
          >
            Please review this document to apply to this job
          </Text>
        </Stack>

        <Box sx={{ width: "100%", mt: isSmallVerticalSpacing ? 2 : 5 }}>
          <Button fullWidth variant="contained" size="medium" onClick={onClick}>
            View details
          </Button>
        </Box>
      </CardContent>
    </CardWithIntent>
  );
}
